// @flow
import { connect } from 'react-redux';
import Component from './component';
import { getIsGroupForProduct } from '~/core/state/products/selectors';
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state, { match }) => {
    const { params: { id } } = match;
    return {
        isGroup: getIsGroupForProduct(state, { id })
    };
};

// $FlowFixMe
export default withRouter(connect(mapStateToProps)(Component));



// WEBPACK FOOTER //
// ./src/components/widgets/flipper/rgb-flipper/index.js